/**
 * Love Store Paris — Page panier (Phase 5)
 * /cart/change.js, /cart/clear.js, refresh section, badge header
 */
(function () {
  'use strict';

  var PRIME_VIP_THRESHOLD = 29900;

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });
  }

  function refreshPrimeVip(root) {
    var progressEl = root.querySelector('[data-lsp-prime-vip]');
    if (!progressEl) return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var total = cart.total_price || 0;
        var progress = Math.min(100, (total / PRIME_VIP_THRESHOLD) * 100);
        var remaining = Math.max(0, PRIME_VIP_THRESHOLD - total);
        var isEligible = total >= PRIME_VIP_THRESHOLD;

        var fill = progressEl.querySelector('[data-lsp-prime-fill]');
        var amounts = progressEl.querySelector('[data-lsp-prime-amounts]');
        var message = progressEl.querySelector('[data-lsp-prime-message]');
        var eligible = progressEl.querySelector('[data-lsp-prime-eligible]');

        if (fill) fill.style.width = progress + '%';
        if (amounts) {
          amounts.textContent = formatMoney(total) + ' / ' + formatMoney(PRIME_VIP_THRESHOLD);
        }

        var track = progressEl.querySelector('.lsp-prime-vip__track');
        if (track) track.setAttribute('aria-valuenow', String(Math.min(total, PRIME_VIP_THRESHOLD)));

        if (isEligible) {
          if (message) message.hidden = true;
          if (eligible) eligible.hidden = false;
        } else {
          if (message) {
            message.hidden = false;
            var strong = message.querySelector('[data-lsp-prime-remaining]');
            if (strong) strong.textContent = formatMoney(remaining);
          }
          if (eligible) eligible.hidden = true;
        }
      })
      .catch(function () { /* silencieux */ });
  }

  function dispatchCartEvents() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  function refreshCartSection(root) {
    var sectionId = root.getAttribute('data-section-id');
    if (!sectionId) {
      window.location.reload();
      return;
    }

    root.classList.add('is-loading');

    fetch('/cart?section_id=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var wrap = document.createElement('div');
        wrap.innerHTML = html;
        var next = wrap.querySelector('[data-lsp-cart]');
        if (!next) {
          window.location.reload();
          return;
        }
        root.replaceWith(next);
        initCart(next);
        dispatchCartEvents();
      })
      .catch(function () {
        window.location.reload();
      });
  }

  function changeLine(root, lineKey, quantity) {
    root.classList.add('is-loading');

    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status && data.description) {
          window.alert(data.description);
          root.classList.remove('is-loading');
          return;
        }
        refreshCartSection(root);
      })
      .catch(function () {
        root.classList.remove('is-loading');
        window.location.reload();
      });
  }

  function clearCart(root) {
    if (!window.confirm('Vider tout le panier ?')) return;

    root.classList.add('is-loading');

    fetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
    })
      .then(function () {
        refreshCartSection(root);
      })
      .catch(function () {
        window.location.reload();
      });
  }

  function initCart(root) {
    if (!root || root.dataset.lspCartInit === 'true') return;
    root.dataset.lspCartInit = 'true';

    var consentInput = root.querySelector('[data-lsp-cart-whatsapp-consent-input]');
    var checkoutForm = root.querySelector('[data-lsp-cart-checkout-form]');

    function saveWhatsappConsent(checked) {
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          attributes: {
            whatsapp_offers_consent: checked ? 'oui' : 'non'
          }
        })
      });
    }

    if (consentInput) {
      consentInput.addEventListener('change', function () {
        saveWhatsappConsent(consentInput.checked).catch(function () { /* silencieux */ });
      });
    }

    if (checkoutForm && consentInput) {
      checkoutForm.addEventListener('submit', function () {
        if (!consentInput.checked) {
          consentInput.removeAttribute('name');
        }
      });
    }

    root.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('[data-lsp-cart-qty-change]');
      if (qtyBtn) {
        e.preventDefault();
        var key = qtyBtn.getAttribute('data-line-key');
        var qty = parseInt(qtyBtn.getAttribute('data-quantity'), 10);
        if (!key || isNaN(qty)) return;

        var line = qtyBtn.closest('[data-lsp-cart-line]');
        if (line && line.hasAttribute('data-lsp-vip-voucher') && qty > 1) {
          return;
        }

        changeLine(root, key, Math.max(0, qty));
        return;
      }

      var removeBtn = e.target.closest('[data-lsp-cart-remove]');
      if (removeBtn) {
        e.preventDefault();
        var removeKey = removeBtn.getAttribute('data-line-key');
        if (!removeKey) return;
        changeLine(root, removeKey, 0);
        return;
      }

      var clearBtn = e.target.closest('[data-lsp-cart-clear]');
      if (clearBtn) {
        e.preventDefault();
        clearCart(root);
      }
    });

    refreshPrimeVip(root);
  }

  function hookCartFetch() {
    if (window.fetch && !window.fetch.__lspCartPatched) {
      var origFetch = window.fetch;
      window.fetch = function () {
        var url = arguments[0];
        var isCartMutation =
          typeof url === 'string' &&
          (url.indexOf('/cart/add') !== -1 ||
            url.indexOf('/cart/change') !== -1 ||
            url.indexOf('/cart/update') !== -1 ||
            url.indexOf('/cart/clear') !== -1);

        return origFetch.apply(this, arguments).then(function (response) {
          if (isCartMutation && response.ok) {
            dispatchCartEvents();
          }
          return response;
        });
      };
      window.fetch.__lspCartPatched = true;
    }
  }

  hookCartFetch();

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-lsp-cart]').forEach(initCart);
  });

  document.addEventListener('shopify:section:load', function (e) {
    var cart = e.target.querySelector('[data-lsp-cart]');
    if (cart) initCart(cart);
  });
})();
